var $ = require('../../modules/$');
require('../../modules/es6.object.get-own-property-descriptor');
module.exports = function getOwnPropertyDescriptor(it, key){
  return $.getDesc(it, key);
};


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap-datetimepicker/~/core-js/library/fn/object/get-own-property-descriptor.js
// module id = 1270
// module chunks = 0